import React, { useEffect, useState } from "react";

import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import {
  CreditCardOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";

import ButtonComponent from "../../components/Button/ButtonComponent";
import IntlMessages from "../../util/IntlMessages";
import FormInput from "../../components/Input/FormInput";
import moment from "moment";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import FormSelectBox from "../../components/SelectBox/SelectBox";
import {
  addBloodGlucoseInprogress,
  getBloodGlucoseListInprogress,
} from "../../appRedux/Patient/Action/Action";
const { Text } = Typography;

const BloodGlucoseScreen = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [currentTime, setCurrentTime] = useState(moment().format("HH:mm"));
  const [selectedDate, setSelectedDate] = useState(null);

  const [disabled, setDisabled] = useState(false);
  const bloodGlucoseListData = useSelector(
    (state) => state?.patientAppointment?.bloodGlucoseList
  );
  const addBloodGlucoseData = useSelector(
    (state) => state?.patientAppointment?.addBloodGlucose
  );

  const goBackHandler = () => {
    history.goBack();
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );
  const [loading, setLoading] = useState(false);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (data) => {
    console.log("datas", data);
    const payload = {
      select_date: moment(data?.date).format("YYYY/MM/DD"),
      time: data?.time,
      glucose_reading: data?.bloodGlucose,
      food_intake_status: data?.foodIntakeStatus,
    };

    dispatch(addBloodGlucoseInprogress(payload));
    if (addBloodGlucoseData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  };
  const disabledDate = (current) => {
    const today = moment().startOf("day");
    const past7Days = moment().subtract(7, "days").endOf("day");
    return current && (current < past7Days || current > moment().endOf("day"));
  };
  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment().format("HH:mm");
      setCurrentTime(now);

      form.setFieldsValue({ time: now });
    }, 1000);
    return () => clearInterval(interval);
  }, [form]);
  const insulinData = bloodGlucoseListData?.data?.data;
  const handleDatePickerChange = (date) => {
    console.log("date", date);
    setSelectedDate(date);
    const selectedDateString = moment(date).format("YYYY-MM-DD");
    const selectedBloodGlucoseData = insulinData.find(
      (item) => item.select_date === selectedDateString
    );
    if (selectedBloodGlucoseData) {
      setDisabled(true);
      form.setFieldsValue({
        data_time: moment(selectedBloodGlucoseData.time, "HH:mm:ss").format(
          "HH:mm"
        ),
        bloodGlucose: selectedBloodGlucoseData.glucose_reading,
        foodIntakeStatus: selectedBloodGlucoseData.food_intake_status,
      });
    } else {
      setDisabled(false);
      form.resetFields(["bloodGlucose", "foodIntakeStatus"]);
    }
  };
  useEffect(() => {
    dispatch(getBloodGlucoseListInprogress());
    form.setFieldsValue({ date: moment() });
  }, []);
  useEffect(() => {
    if (bloodGlucoseListData?.success) {
      const currentDate = form.getFieldValue("date");
      handleDatePickerChange(currentDate);
    }
  }, [bloodGlucoseListData]);
  useEffect(() => {
    if (addBloodGlucoseData?.success) {
      history.push("/health-management");
    }
  }, [addBloodGlucoseData]);
  useEffect(() => {
    if (addBloodGlucoseData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [addBloodGlucoseData]);
  return (
    <Card>
      <Row className="p-10 Add-button">
        <Col>
          <Typography className="header-tag">
            {<IntlMessages id={"Addnew.bloodGlucose"} />}
          </Typography>
          {/* <Text disabled className="mt-30">
            Readings can be updated for last 7 days
          </Text> */}
        </Col>
        <Col>
          <ButtonComponent
            className="buttons"
            icon={<PlusCircleOutlined />}
            type="primary"
            label={<IntlMessages id={"back"} />}
            onClick={goBackHandler}
          />
        </Col>
      </Row>
      <Spin indicator={antIcon} spinning={loading}>
        <Row gutter={[16, 16]}>
          <Col xl={12} lg={12} md={12} xs={24} m={24}>
            <Alert
              message="Readings can be updated for last 7 days"
              type="info"
              showIcon
            />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24} m={24}>
            <Form
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              colon={"true"}
              onFinish={onFinish}
              autoComplete="off"
              form={form}
              onFinishFailed={onFinishFailed}
            >
              <Row>
                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="ml-5">
                  <Form.Item
                    name="date"
                    label={<IntlMessages id={"Addnew.health.label.date"} />}
                    rules={[
                      {
                        required: true,
                        message: (
                          <IntlMessages id={"Addnew.health.validator.date"} />
                        ),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disabledDate}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      onChange={handleDatePickerChange}
                    />
                  </Form.Item>
                </Col>
                <Col xl={11} lg={11} md={11} sm={24} xs={24}>
                  {!disabled ? (
                    <FormInput
                      labelCol={"24"}
                      wrapperCol={"24"}
                      readOnly={true}
                      type="text"
                      name={"time"}
                      label={<IntlMessages id={"Addnew.health.label.time"} />}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id={"Addnew.health.validator.time"} />
                          ),
                        },
                      ]}
                    />
                  ) : (
                    <FormInput
                      labelCol={"24"}
                      wrapperCol={"24"}
                      readOnly={true}
                      type="text"
                      name={"data_time"}
                      label={<IntlMessages id={"Addnew.health.label.time"} />}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id={"Addnew.health.validator.time"} />
                          ),
                        },
                      ]}
                    />
                  )}
                </Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="ml-5">
                  <FormInput
                    labelCol={"24"}
                    wrapperCol={"24"}
                    readOnly={disabled}
                    type="number"
                    name={"bloodGlucose"}
                    label={
                      <IntlMessages
                        id={"Addnew.health.label.bloodGlucoseReading"}
                      />
                    }
                    suffix={
                      <Text style={{ color: "#038FDE" }} strong>
                        mg/dL
                      </Text>
                    }
                    rules={[
                      {
                        required: true,
                        message: (
                          <IntlMessages
                            id={"Addnew.health.validator.bloodGlucoseReading"}
                          />
                        ),
                      },
                    ]}
                  />
                </Col>
                <Col xl={24} lg={24} md={24} xs={24} m={24} className="ml-5">
                  {" "}
                  <Form.Item
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    label={
                      <IntlMessages
                        id={"Addnew.health.label.foodIntakeStatus"}
                      />
                    }
                    name={"foodIntakeStatus"}
                    rules={[
                      {
                        required: true,
                        message: (
                          <IntlMessages
                            id={"Addnew.health.validator.foodIntakeStatus"}
                          />
                        ),
                      },
                    ]}
                  >
                    <Radio.Group name="radiogroup" disabled={disabled}>
                      <Space direction="vertical">
                        <Radio value={1}>Fasting Blood Sugar </Radio>
                        <Radio value={2}>Before Meal</Radio>
                        <Radio value={3}>After Meal (2 hrs)</Radio>
                        <Radio value={4}>Random Blood Sugar</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col
                  xl={23}
                  align="right"
                  className="button-alignment-pharmacy cancel-btn mr-10"
                >
                  <Link
                    to={{
                      pathname: "/health-management",
                    }}
                  >
                    <ButtonComponent
                      type="danger"
                      label="Cancel"
                      className="btn-cancel secondary-color"
                    />
                  </Link>
                  <ButtonComponent
                    icon={<CreditCardOutlined />}
                    label={"Update Blood Glucose"}
                    htmlType="submit"
                    type="primary"
                    disabled={disabled}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Spin>{" "}
    </Card>
  );
};

export default BloodGlucoseScreen;
